export default __webpack_public_path__ + "static/media/teleconsult-on-demand-2.630beae6.png";